import {Component, OnDestroy, Input, OnInit} from '@angular/core';
import {FilterBase} from "../../../../../models/filter-base";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {FilterbaseService} from "../../filter-base/services/filterbase.service";

@Component({
    selector: 'app-date-field',
    templateUrl: './date-field.component.html',
    styleUrls: ['./date-field.component.scss'],
    standalone: false
})
export class DateFieldComponent implements OnDestroy, OnInit {
  /** Service subscriptions end with the component (they used to leak). */
  private readonly destroy$ = new Subject<void>();
  ngOnDestroy(): void { this.destroy$.next(); this.destroy$.complete(); }

  @Input() filterBase!: FilterBase;
  @Input() widthSize: number = 160;
  @Input() hideTitle: boolean =false;
  selectedValue: any;
  constructor(private filterBaseService: FilterbaseService) { }

  ngOnInit(): void {
    this.selectedValue = this.filterBaseService.getQuestion(this.filterBase.key) || '';
    this.filterBaseService.getRemoveEvent().pipe(takeUntil(this.destroy$)).subscribe(key => {
      if (key === this.filterBase.key) this.selectedValue = '';
    });
  }

  onDateChange(value: string): void {
    if (value) this.filterBaseService.addQuestion(this.filterBase.key, value);
    else this.filterBaseService.deleteQuestion(this.filterBase.key);
  }

}
